import httpService from "./httpService";
import utils from "./utils";

export default {
  getAllBookDoc(example, pageable) {
    let params = utils.merge(
      example,
      (pageable = utils.initPageableParams(pageable))
    );
    return httpService.get("/bookdoc", {params: params});
  },

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get("/bookdoc", {params: params});
  },

  count(config) {
    // let params = utils.merge(keyword,example);
    return httpService.get("/bookdoc/count", config);
  },

  save(form) {
    return httpService.post("/bookdoc", form);
  },

  edit(id, form) {
    return httpService.put(`/bookdoc/${id}`, form);
  },

  delete(id) {
    return httpService.delete(`/bookdoc/${id}`);
  },

  findById(id) {
    return httpService.get(`/bookdoc/${id}`);
  },

  requestUsers(id) {
    return httpService.get(`/bookdoc/requestUsers/${id}`);
  },

  findByBookNumberAndBookId(bookNumber, bookId) {
    let params = {bookNumber: bookNumber, bookId: bookId};
    return httpService.get(`/bookdoc/findByBookNumberAndBookId`, {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/bookDocService.js